import { ValidationIssue } from '@decisions/server/DecisionsFramework';
import { RuleOutputPath } from '@decisions/server/DecisionsFramework/Design/Flow';
import { ActionModel } from './models/ActionModel';
import { ActionsModel } from './models/ActionsModel';

const ANCHOR_VALIDATION_CODE = 1;
const VALUE_VALIDATION_CODE = 2;

export function getActions(actionsModel: ActionsModel, outputPath: RuleOutputPath) {
  let actions: ActionModel[] = [];
  switch (outputPath) {
    case RuleOutputPath.True:
      actions = actionsModel.TrueActions;
      break;
    case RuleOutputPath.False:
      actions = actionsModel.FalseActions;
      break;
    case RuleOutputPath.MissingData:
      actions = actionsModel.MissingDataActions;
      break;
  }

  return actions;
}

export function getAnchorIssues(issues: ValidationIssue[]) {
  return issues.filter(item => item.ValidationCode === ANCHOR_VALIDATION_CODE);
}

export function getValueIssues(issues: ValidationIssue[]) {
  return issues.filter(item => item.ValidationCode === VALUE_VALIDATION_CODE);
}

export const RuleActionUtils = {
  getActions,
};
